var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Leaves") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M8 16c1.547 0 2.802.197 4.402.621.35.093 1.575.437 1.56.433 2.39.66 4.216.946 7.038.946 4.134 0 7.14-1.718 9.204-5.256a1.5 1.5 0 1 1 2.592 1.511C30.193 18.717 26.199 21 21 21c-3.116 0-5.202-.328-7.836-1.054-.003-.001-1.206-.338-1.532-.425C10.264 19.158 9.256 19 8 19c-1.854 0-3.38.174-4.594.46a9.078 9.078 0 0 0-1.01.293c-.14.05-.214.083-.225.088A1.5 1.5 0 0 1 0 18.5C0 8.818 9.55 0 19.5 0c6.381 0 10.812 1.477 13.192 4.588a1.5 1.5 0 1 1-2.384 1.823C28.61 4.189 25.04 3 19.5 3 11.881 3 4.418 9.28 3.18 16.438 4.53 16.161 6.132 16 8 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M11.066 12.889a1.5 1.5 0 0 1-1.132-2.779c9.349-3.808 19.715-3.808 31.04-.033a1.5 1.5 0 1 1-.948 2.846c-10.675-3.559-20.309-3.559-28.96-.034zm32.36 6.29a58.812 58.812 0 0 1-4.87 3.457c-.616.392-1.209.756-1.97 1.212l-.895.535c-.346.206-.6.36-.845.509-.851.518-1.505.943-2.132 1.394-1.252.9-2.386 1.903-3.612 3.231-2.708 2.934-3.468 7.798-2.13 14.697a1.5 1.5 0 0 1-2.945.571c-1.502-7.745-.596-13.548 2.87-17.303 1.364-1.477 2.65-2.614 4.066-3.632.697-.501 1.41-.965 2.321-1.52.254-.155.516-.312.868-.523l.892-.532c.74-.444 1.312-.794 1.902-1.17a55.821 55.821 0 0 0 4.627-3.285c2.61-2.05 4.2-3.834 4.981-5.325.262-.5.408-.921.468-1.267.03-.178.032-.294.026-.355-.508-1.579 1.755-2.66 2.71-1.19 6.513 10.03 7.906 23.968.963 33.688-5.306 7.428-11.502 10.708-18.455 9.61a1.5 1.5 0 0 1 .468-2.963c5.714.902 10.85-1.817 15.545-8.39 5.47-7.657 5.052-18.547.705-27.262-1.018 1.705-2.805 3.651-5.557 5.813zm3.622-9.306a.285.285 0 0 0-.002-.01l.002.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M45.063 25.069a1.5 1.5 0 0 1 2.874.862C44.809 36.358 35.55 45.959 20.25 54.799A1.5 1.5 0 1 1 18.75 52.2c14.7-8.493 23.441-17.559 26.313-27.132z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaves);
export default __webpack_public_path__ + "static/media/leaves.57d9c71f21550bcc8ea4fdfa63c2b661.svg";
export { ForwardRef as ReactComponent };